import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/messaging';
// import 'firebase/';
firebase.initializeApp({
    apiKey: 'AIzaSyDXoYtLriLUeNACCuU4b3B61N7XeU7SMcs',
    authDomain: 'dubbie-bee-hive.firebaseapp.com',
    databaseURL: 'https://dubbie-bee-hive.firebaseio.com',
    projectId: 'dubbie-bee-hive',
    storageBucket: 'dubbie-bee-hive.appspot.com',
    messagingSenderId: '408549638938'
    // appId: "1:408549638938:web:913c5d7ce64f6ba491e2a3"
});
export default firebase;
//# sourceMappingURL=firebase.js.map